import { useEffect } from "react";

const STORAGE_KEY_PREFIX = "fp_setup_events_seen";
// Matches the 30-day SDK event window of the maturity tiers.
const MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000;

function storageKey(envID: string): string {
  return `${STORAGE_KEY_PREFIX}:${envID}`;
}

/**
 * Whether the install wizard saw an event from this environment recently.
 * Bridges the hours before event traffic reaches the warehouse, and outlives
 * the wizard session.
 */
export function hasSeenEventsRecently(
  envID: string | undefined,
  now = Date.now(),
): boolean {
  if (!envID) {
    return false;
  }
  try {
    const seenAt = Number(localStorage.getItem(storageKey(envID)));
    return seenAt > 0 && now - seenAt < MAX_AGE_MS;
  } catch {
    return false;
  }
}

export function useRecordEventsSeen(
  envID: string | undefined,
  seen: boolean,
): void {
  useEffect(() => {
    if (!envID || !seen || hasSeenEventsRecently(envID)) {
      return;
    }
    try {
      localStorage.setItem(storageKey(envID), String(Date.now()));
    } catch {
      // Losing this only delays the install step showing as done until event
      // traffic reaches the warehouse.
    }
  }, [envID, seen]);
}
